import React from "react";
import { ControlLabel, HelpBlock } from "react-bootstrap";
import Select from "react-select";
import { StyledFormGroup } from "./styles.const";
import { theme } from "../../../styles/theme";

const SelectField = ({
  field,
  form: { errors, touched = {}, values, setFieldValue },
  label = "",
  options,
  customStyles = {},
  labelStyles = {},
  customComponents = {},
  placeholder = "",
  disabled = false,
  handleChange = null,
  isError = false,
  showMenuPortal = false,
  className,
  errorCondition = null,
  ...props
}) => {
  const { name = "", onBlur = "", value } = field;
  const isMulti = props.isMulti || false;
  let onSelectChange = null;


  if (typeof handleChange === "function") {
    onSelectChange = handleChange;
  } else {
    onSelectChange = (option) => {
      if (isMulti) {
        const values = option ? option.map(opt => opt.value) : [];
        setFieldValue(name, values);
      } else {
        setFieldValue(name, option ? option.value : "");
      }
    };
  }

  const CustomOption = (props) => {
    const { data, innerRef, innerProps, getStyles, isSelected } = props;
    const optionStyles = getStyles("option", props);

    return (
      <div ref={innerRef} {...innerProps} style={{ 
        ...optionStyles,
        display: "flex",
        padding: "8px 16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "4px",
        alignSelf: "stretch",
        }}>
        <div  style = {{
           color: (!isSelected) ?  "var(--Grey-95, #0C0D0D)" : optionStyles.color , // Using CSS variable with fallback color
           fontSize: "14px",
           fontStyle: "normal",
           fontWeight: 400,
           lineHeight: "19px",
        }}>{data.label}</div>
        {data.subText &&  <div style={{ 
          color: (!isSelected) ?  "#94989E" : optionStyles.color,
          fontSize: "10px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "14px"
           }}>
            {data.subText}
        </div>}
      </div>
    );
  };

  return (
    <StyledFormGroup
      controlId={name}
      className = {'select-component-form-group'}
      validationState={((touched[name] && errors[name] )|| errorCondition || isError) ? "error" : null}
    >
      {label && (
        <div className="text-area-tooltip">
          <ControlLabel style={labelStyles}>{label}</ControlLabel>
        </div>
      )}
      <Select
        backspaceRemoves
        isDisabled={disabled}
        options={options}
        styles={theme.styles.selectWithInput(isError || (touched[name] && errors[name]), customStyles)}
        name={name}
        isClearable={true}
        onBlur={onBlur}
        className = {`${className} dropdown-component full-width`}
        components={{ Option: CustomOption }}
        placeholder={placeholder}
        value={isMulti 
          ? (Array.isArray(value) ? options?.filter((option) => value.includes(option.value)) : [])
          : (options?.find((option) => option.value === value) || "")
        }
        onChange={onSelectChange}
        menuPortalTarget={showMenuPortal ? document.body : null} // Append menu to the body
        {...props}
      />

      {(errorCondition || touched[name] || isError) && (
        <HelpBlock>{(errorCondition || touched[name]) && errors[name]}</HelpBlock>
      )}
    </StyledFormGroup>
  );
};

export { SelectField };
